<template>
  <div class="list-table-file-title ellipsis">
    <mk-popover
      placement="top-start"
      trigger="hover"
      popper-class="list-table-file-title-popper-class"
      :disabled="!scope.row.disableFormat"
    >
      <p style="font-size:13px; color:#595959;">
        暂不支持该格式
      </p>

      <p slot="reference">
        {{ scope.row.title }}.{{ scope.row.suffix }}
      </p>
    </mk-popover>
  </div>
</template>

<script>
export default {
  name: 'ListTableFileTitle',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
.list-table-file-title-popper-class {
  padding: 10px;
  min-width: unset;
}
</style>
